import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { BrowserRouter, Redirect, Route, Switch,useLocation } from 'react-router-dom';
import NavBarComp from './Components/NavBarComp';
import ProtectedRoute from './ProtectedRoutes';
import { AdminLogin } from './Screens/AdminLogin';

import { AdminSignup } from './Screens/AdminSignup';
import AdminUpdate from './Screens/AdminUpdate';
import ErrorPage from './Screens/ErrorPage';
import { ExtraClass } from './Screens/ExtraClass';
import Home from './Screens/Home';
import { MainClass } from './Screens/MainClass';
import { NotesBooks } from './Screens/NotesBooks';
import SeprateCourses from './Screens/SeprateCourses';
import { StudentView } from './Screens/StudentView';
import { storeContext } from './Store/storeContext';
import { getCurrentUser } from './utils/NewAuthService';

export const Router = () => {
  const [state, dispatch] = useContext(storeContext);
  
  // const _checkauth = () => {
  //   try {
  //     const user = await getCurrentUser()
  //     if (user) {
  //       user
  //         .jwt(true)
  //         .then((response) => {
  //           dispatch({ type: 'SET_USER', payload: user });
  //           dispatch({ type: 'AUTHENTICATION' });
  //         })
  //         .catch(console.error);
  //     }
  //   } catch {
  //     window.location.href = '/';
  //   }
  // };

  useEffect(()=>{
    async function checkAuth(){
     try{
      const user = await getCurrentUser()
      if(user){
        dispatch({ type: 'SET_USER', payload: user });
        dispatch({ type: 'AUTHENTICATION' });
      }
     }
     catch(ex){
      localStorage.removeItem('tokens');
      localStorage.removeItem('user');
      throw ex
     }
      
    }
    checkAuth()
  },[dispatch]);
  return (
    <BrowserRouter>
      {state.isAuthenticated ? (
        <NavBarComp
          islogin={state.isAuthenticated}
          name={state.user.name}
          email={state.user.email}
        />
      ) : null}
      <Switch>
        <Route exact path='/'>
          {state.isAuthenticated ? (
            <Redirect to='/sepratecourses' />
          ) : (
            <AdminLogin />
          )}
        </Route>

        <Route
          path='/admin'
          exact
          render={(props) => <AdminSignup {...props} />}
        />
        <Route
          path='/admin/update'
          exact
          render={(props) => <AdminUpdate {...props} />}
        />
        <Route
          path='/studentdata/C584C8B159135458790A4753DFE6C9D6'
          exact
          render={(props) => <StudentView {...props} />}
        />
        <ProtectedRoute
          isAuth={state.isAuthenticated}
          exact
          path='/home/:role/:name'
          component={Home}
        />
        <ProtectedRoute
          exact
          isAuth={state.isAuthenticated}
          path='/sepratecourses'
          component={SeprateCourses}
        />
        <ProtectedRoute
          isAuth={state.isAuthenticated}
          exact
          path='/mainclass/:role'
          component={MainClass}
        />
        <ProtectedRoute
          isAuth={state.isAuthenticated}
          exact
          path='/extraclass/:role'
          component={ExtraClass}
        />
        <ProtectedRoute
          isAuth={state.isAuthenticated}
          exact
          path='/notesbooks/:role'
          component={NotesBooks}
        />
        <Route path='/404' exact render={(props) => <ErrorPage {...props} />} />
        <Redirect from='*' to='/404' />
      </Switch>
    </BrowserRouter>
  );
};
